export const PHARMACIES_LOADED = 'loaded-pharmacies';
export const UPDATE_PHARMACY = 'update-pharmacy';
export const UPDATED_PHARMACY = 'updated-pharmacy';
export const SEARCH_REQUEST_PHARMACIES = 'search-pharmacies';
export const REQUEST_PHARMACY = 'request-pharmacy';

export function requestPharmacy(payload) {
    return {
        type: REQUEST_PHARMACY,
        payload: payload
    }
}

export function loadedPharmacies(payload) {
    return {
        type: PHARMACIES_LOADED,
        payload: payload
    };
}

export function updatePharmacy(payload) {
    return {
        type: UPDATE_PHARMACY,
        id: payload.id,
        data: payload
    };
}

export function updatedPharmacy() {
    return {
        type: UPDATED_PHARMACY
    };
}

export function searchPharmacies(payload) {
    return {
        type: SEARCH_REQUEST_PHARMACIES,
        data: payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/pharmacies.action.js